<template>
  <div class="dialog-root">
    <div class="container">
      <avue-form ref="formRef" :option="formOption" v-model="formData1"> </avue-form>
      <h4>购买方信息</h4>
      <avue-form ref="formRef2" :option="formOption2" v-model="formData2"> </avue-form>
      <h4>发票明细记录</h4>
      <avue-crud
        ref="crudRef"
        :option="tableOption"
        :data="tableData"
      ></avue-crud>
    </div>
  </div>
</template>

<script>
import {
  getDetail,
} from "@/api/v4ward/digitaltickets/taxinvoicerecord/TaxInvoiceRecord.js";
import {mapGetters} from "vuex";

export default {
  components: {

  },
  props: {
    searchObj:{},
  },
  data() {
    return {
      formOption: {
        labelWidth: 100,
        menuBtn: false,
        column: [
          {
            label: '发票记录编号',
            prop: 'invoiceBillNo',
            span: 8,
            disabled: true,
          },
          {
            label: '发票号码',
            prop: 'invoiceNo',
            disabled: true,
            span: 8,
          },
          {
            label: '客户',
            prop: 'customer',
            disabled: true,
            span: 8,
          },
          {
            label: '房号',
            prop: 'roomName',
            disabled: true,
            span: 8,
          },
          {
            label: '发票类型',
            prop: 'invoiceTypeName',
            disabled: true,
            span: 8,
          },
          {
            label: '发票标识',
            prop: 'invoiceFlag',
            disabled: true,
            type: 'select',
            span: 8,
            dicData: [
              { label: '红票', value: 'red' },
              { label: '蓝票', value: 'blue' },
            ],
          },
          {
            label: '金额(含税)',
            prop: 'payAmount',
            span: 8,
            disabled: true,
          },
          {
            label: '开票时间',
            prop: 'invoiceTime',
            span: 8,
            disabled: true,
          },
          {
            label: '开票状态',
            prop: 'invoiceStatus',
            span: 8,
            type: 'select',
            disabled: true,
            dicData: [
              { label: '进行中', value: '0' },
              { label: '开票成功', value: '1' },
              { label: '开票失败', value: '2' },
              { label: '已红冲', value: '3' },
              { label: '开票中', value: '4' },
            ],
          },
          {
            label: '开票人',
            prop: 'invoiceUser',
            span: 8,
            disabled: true,
          },
          {
            label: '销售方信息',
            prop: 'sellerName',
            span: 8,
            disabled: true,
          },
          {
            label: '发票下载地址',
            prop: 'invoiceUrl',
            span: 24,
            disabled: true,
          },
          {
            label: '开票失败原因',
            prop: 'blueErrorMsg',
            span: 24,
            disabled: true,
          },
          {
            label: '红冲失败原因',
            prop: 'redErrorMsg',
            span: 24,
            disabled: true,
          },
          {
            label: '开票备注',
            prop: 'description',
            span: 24,
            disabled: true,
          },
        ],
      },
      formOption2: {
        labelWidth: 100,
        menuBtn: false,
        column: [
          {
            label: '发票抬头',
            prop: 'name',
            span: 8,
            disabled: true,
          },
          {
            label: '纳税人识别号',
            prop: 'taxNo',
            disabled: true,
            span: 8,
          },
          {
            label: '地址',
            prop: 'address',
            disabled: true,
            span: 8,
          },
          {
            label: '电话',
            prop: 'phone',
            disabled: true,
            span: 8,
          },
          {
            label: '开户银行',
            prop: 'depositBank',
            disabled: true,
            span: 8,
          },
          {
            label: '开户银行账号',
            prop: 'bankNo',
            disabled: true,
            span: 8,
          },
          {
            label: '接收邮箱',
            prop: 'receiveMailbox',
            disabled: true,
            span: 8,
          },
          {
            label: '接收电话',
            prop: 'receivePhone',
            disabled: true,
            span: 8,
          },
        ],
      },
      formData1:{

      },
      formData2:{

      },
      tableOption: {
        addBtn: false,
        menu: false,
        border: true,
        columnBtn: false,
        refreshBtn:false,
        column: [
          {
            width: 80,
            label: '费用类型',
            prop: 'feeItemName',
          },
          {
            width: 80,
            label: '收费项目',
            prop: 'taxFeeSortName',
          },
          {
            label: '账单周期',
            prop: 'billcycleNo',
          },
          {
            label: '开始日期',
            prop: 'startDate',
            width: 130,
          },
          {
            label: '结束日期',
            prop: 'endDate',
            width: 130,
          },
          {
            label: '应收金额',
            prop: 'shouldAmount',
          },
          {
            label: '优惠金额',
            prop: 'discountAmount',
          },
          {
            label: '实收金额',
            prop: 'payAmount',
          },
          {
            label: '开票金额(含税)',
            prop: 'invoiceAmountWithTax',
            width: 110,
          },
          {
            label: '税率',
            prop: 'taxRate',
          },
          {
            label: '税额',
            prop: 'taxAmount',
          },
          {
            label: '开票金额(不含税)',
            prop: 'invoiceAmountWithoutTax',
            width: 120,
          },
          {
            label: '状态',
            prop: 'payStatusName',
          },
          {
            label: '支付方式',
            prop: 'payTypeName',
            width: 90,
          },
          {
            label: '支付时间',
            prop: 'payTime',
            width: 130,
          },
          {
            label: '收费人',
            prop: 'cashierName',
          },
        ],
      },
      tableData:{

      },

    };
  },
  watch: {
  },
  mounted(){
    this.adjustView();
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  created(){
    console.log("进来了啦啦啦");
    this.initData();
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        delBtn: this.vaildData(this.permission.feeitemtax_delete, false),
        editBtn: this.vaildData(this.permission.feeitemtax_edit, false),
      };
    },
  },
  methods: {
    initData(){
      getDetail({invoiceBillNo:this.searchObj.invoiceBillNo, invoiceNo:this.searchObj.invoiceNo}).then(( res ) => {
        this.formData1 = res.data.feeInvoiceInfo;
        this.formData2 = res.data.invoicePurchaser;
        this.tableData = res.data.invoiceRecordDetailList;
      });
    },
    doClose() {
      this.searchObj = {};
      this.$emit('close');
    },
    adjustView() {
      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
  }
};
</script>

<!--最大化-->
<style lang="scss" scoped>
::v-deep .el-form-item {
  width: 100%;
}
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}
</style>
